import React, { lazy } from "react";
import Layout from "../components/layout";
// import AuthorsSearch from "../components/search-authors/index"
import { Seo } from "../components/seo";
import { SuspenseHelper } from "../components/SuspenseHelper";
const AuthorsSearch = lazy(() => import("../components/search-authors/index"));

const Authors = () => {
  const searchIndices = [
    {
      name: `authors`,
      title: `authors`,
    },
  ];
  return (
    <Layout mainClass={"authors archive"}>
      <section className="archive description">
        <h2 className="archive-title">Our Authors</h2>
      </section>
      <SuspenseHelper fallback={<div className="search-authors search-archive"></div>}>
        <AuthorsSearch indices={searchIndices} />{" "}
      </SuspenseHelper>
    </Layout>
  );
};

export default Authors;

export function Head() {
  return (
    <Seo
      title="Caucasus Edition | Authors"
      description="Our Authors"
      pathname="/authors/"
    ></Seo>
  );
}
